import convert from 'color-convert';
const hex2rgbRawStr = (hex) => {
    if (!hex) return;
    const [r, g, b] = convert.hex.rgb.raw(hex)
    return `${r},${g},${b}`
}
const hexFilter = (hex, filter = { r: 0, g: 0, b: 0 }) => {
    if (filter.r === 0 && filter.g === 0 && filter.b === 0) return hex
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    if (!result) return `#000000`;
    const rgb = result
        ? {
            r: parseInt(result[1], 16) + filter.r,
            g: parseInt(result[2], 16) + filter.g,
            b: parseInt(result[3], 16) + filter.b
        }
        : {};
    return convert.rgb.hex.raw([inRange(rgb.r), inRange(rgb.g), inRange(rgb.b)])

};

const inRange = number => {
    if (number < 0) return 0
    if (number > 255) return 255
    return number
}

const hexThreshold = hex => {
    hex = getColor(hex);
    hex = hex.substring(0, 7)
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!result) return 1;
    const threshold =
        (parseInt(result[1], 16) * 0.2126 +
            parseInt(result[2], 16) * 0.7152 +
            parseInt(result[3], 16) * 0.0722) /
        255;

    return threshold;
};

const hex2Threshold = hex => {
    hex = getColor(hex);
    hex = hex.substring(0, 7)
    return hexThreshold(hex) > 0.5 ? "black" : "white";
};


const percentToHex = (p) => {
    const intValue = Math.round(p / 100 * 255); // map percent to nearest integer (0 - 255)
    const hexValue = intValue.toString(16); // get hexadecimal representation
    return hexValue.padStart(2, '0').toUpperCase(); // format with leading 0 and upper case characters
}


const getColor = function (val = '#000000', alpha = 100) {
    if (val === null) val = '#000000';
    if (!val.includes('--tpc-') && !val.includes('#')) return val
    const is_template = !val.includes("#")
    if (is_template) {
        // val = val.replace(/^rgba\((.+)\)$/, "$1")
        val = val.replace(/^var\((.+)\)$/, "$1")
        return `rgba(var(${val}), ${alpha}%)`
    } else {
        const alphahex = (typeof alpha === 'number') ? percentToHex(alpha) : 'FF'
        return `${val}${alphahex}`
    }
}

// https://github.com/PimpTrizkit/PJs/wiki/12.-Shade,-Blend-and-Convert-a-Web-Color-(pSBC.js)
const shadeHexColor = (color, percent) => {
    var f = parseInt(color.slice(1), 16), t = percent < 0 ? 0 : 255, p = percent < 0 ? percent * -1 : percent, R = f >> 16, G = f >> 8 & 0x00FF, B = f & 0x0000FF;
    return "#" + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
}

const genShadeColor = (hex) => {
    let shade = getShade(convert.hex.rgb.raw(hex))
    const [r, g, b] = convert.hex.rgb.raw(hex)
    return new Array(5).fill(0).map((_, index) => {
        const seq = (5 - index)
        if ((shade === 0 && shade + 1 === seq) || seq === shade) {
            return hex;
        } else if (shade > 2) {
            const newrgb = [inRange(r * seq / shade), inRange(g * seq / shade), inRange(b * seq / shade)]
            return "#" + convert.rgb.hex.raw(newrgb).toUpperCase();
        } else {
            return shadeHexColor(
                hex,
                1 / 5 * (5 - index - shade - (index * 0.1))
            )
        }
    })
}
const getShade = ([r, g, b]) => {
    return Math.ceil((r + g + b) / 765 / 0.2);
}

const hexToHsv = (hex) => {
    return convert.hex.hsv.raw(hex)
}
const hexToHsl = (hex) => {
    return convert.hex.hsl.raw(hex)
}
const hsvToHex = (hsv) => {
    return '#' + convert.hsv.hex.raw(hsv)
}
const hslToHex = (hsl) => {
    return '#' + convert.hsl.hex.raw(hsl)
}

const colorKey = (color, shade) => {
    return `--tpc-${color}${shade || ''}`
}

const rgbToHex = (r, g, b) => {
    let rr = parseInt(r)
    let gg = parseInt(g)
    let bb = parseInt(b)
    return "#" + ((1 << 24) + (rr << 16) + (gg << 8) + bb).toString(16).slice(1);
}

export { hexFilter, hex2Threshold, percentToHex, getColor, hexThreshold, shadeHexColor, hexToHsv, hsvToHex, hslToHex, hexToHsl, genShadeColor, colorKey, hex2rgbRawStr, rgbToHex };
export default { hexFilter, hex2Threshold, percentToHex, getColor, hexThreshold, shadeHexColor, hexToHsv, hsvToHex, hslToHex, hexToHsl, genShadeColor, colorKey, hex2rgbRawStr, rgbToHex };
